import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.45 14.096a.913.913 0 1 0 0-1.827.913.913 0 0 0 0 1.827Z"
    />
    <path
      fill="currentColor"
      d="M18.626 13.742a.913.913 0 1 0 0-1.827.913.913 0 0 0 0 1.827Z"
    />
    <path
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M21.892 15.067 5.65 19.962a.88.88 0 0 1-1.094-.584L1.438 9.028a.88.88 0 0 1 .584-1.095l16.242-4.895a.88.88 0 0 1 1.094.584l3.119 10.35a.865.865 0 0 1-.585 1.095ZM2.31 11.932l17.928-5.406"
    />
  </svg>
);
export const CardSmallIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
